import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setHeaderHeight } from 'store/header/header-actions';
export function useElementHeight() {
    const dispatch = useDispatch();
    const ref = useRef(null);
    useEffect(() => {
        const updateHeight = () => {
            if (ref.current) {
                dispatch(setHeaderHeight(ref.current.offsetHeight));
            }
        };
        const resizeObserver = new ResizeObserver(updateHeight);
        if (ref.current) {
            resizeObserver.observe(ref.current);
        }
        return () => {
            resizeObserver.disconnect();
        };
    }, [dispatch]);
    return [ref];
}
